const LabelMapper = {
  total: 'Total',
  revenue: 'Revenue',
  ratesAndAnnualCharges: 'Rates and Annual Charges',
  userChargesAndFees: 'User charges and fees',
  interestAndInvestmentRevenue: 'Interest and investment revenue',
  otherRevenue: 'Other revenue',
  grantsAndContributionsProvidedForOperating:
    'Grants and Contributions Provided for Operating Purposes',
  grantsAndContributionsProvidedForCapital:
    'Grants and Contributions Provided for Capital Purposes',
  netGainsFromTheDisposalsOfAssets: 'Net Gains from the Disposal of Assets',
  NetShareOfInterestsInJointVenturesAndAssociates:
    'Net Share of Interests in Joint Ventures and Associates',
  expenses: 'Expenses',
  employeeBenefitsAndOnCosts: 'Employee Benefits and on Costs',
  borrowingCosts: 'Borrowing Costs',
  materialsAndContracts: 'Materials and Contracts',
  depreciationAndAmortisation: 'Depreciation and amortisation',
  impairment: 'Impairment',
  otherExpenses: 'Other expenses',
  netLossesFromDisposalOfAssets: 'Net Losses from Disposal of Assets',
  operatingResult: 'Operating Result',
  assets: 'Assets',
  currentAssets: 'Current assets',
  nonCurrentAssets: 'Non-current assets',
  miscellaneousNonCurrentAssets: 'Miscellaneous non-current assets',
  liabilities: 'Liabilities',
  currentLiabilities: 'Current liabilities',
  nonCurrentLiabilities: 'Non-current liabilities',
  miscellaneousCurrentLiabilities: 'Miscellaneous current liabilities',
  miscellaneousNonCurrentLiabilities: 'Miscellaneous non-current liabilities',
  operatingPerformance: 'Operating Performance',
  ownSourceOperatingRevenue: 'Own Source Operating Revenue',
  unrestrictedCurrentRatio: 'Unrestricted Current Ratio',
  debtServiceCoverRatio: 'Debt Service Cover Ratio',
  ratesAndAnnualChargesOutstandingPercentage:
    'Rates and Annual Charges Outstanding Percentage',
  cashExpenseCoverRatio: 'Cash Expense Cover Ratio',
  ordinaryRates: 'Ordinary Rates',
  specialRates: 'Special Rates',
  annualCharges: 'Annual Charges',
  specificUserCharges: 'Specific User Charges',
  statutoryAndRegulatoryCharges: 'Statutory and Regulatory Charges',
  otherCharges: 'Other Charges',
  cashAndCashEquivalents: 'Cash and cash equivalents',
  currentInvestments: 'Current investments',
  currentReceivables: 'Current receivables',
  currentInventories: 'Current inventories',
  otherCurrentAssets: 'Other current assets',
  nonCurrentAssetsHeldForSale: 'Non-current assets held for sale',
  nonCurrentInvestments: 'Non-current Investments',
  nonCurrentReceivables: 'Non-current receivables',
  nonCurrentInventories: 'Non-current Inventories',
  infrastructurePropertyPlantAndEquipment:
    'Infrastructure and property, plant and equipment',
  investmentsAccountedForUsingTheEquityMethod:
    'Investments Accounted for using the Equity method',
  investmentProperty: 'Investment Property',
  intangibleAssets: 'Intangible assets',
  currentPayables: 'Current payables',
  currentBorrowings: 'Current borrowings',
  currentProvisions: 'Current provisions',
  incomeReceivedInAdvance: 'Income Received in Advance',
  nonCurrentPayables: 'Non-current payables',
  nonCurrentBorrowings: 'Non-current borrowings',
  nonCurrentProvisions: 'Non-current provisions',
  // New for qld
  otherRevenues: 'Other Revenues',
  capitalExpenses: 'Capital Expenses',
  infrastructurePropertyPlantEquipment:
    'Infrastructure and property, plant and equipment',
  operatingSurplusRatio: 'Operating surplus ratio',
  grantsContributionsProvidedForOperating:
    'Grants and contributions provided for operating',
  averageOsr: 'Average operating surplus ratio',
  grantsContributionsProvidedForCapital:
    'Grants and contributions provided for capital',
  miscellaneous: 'Miscellaneous',
  netFinancialLiabilities: 'Net financial liabilities',
  assetSustainabilityRatio: 'Asset sustainability ratio ',
  averageAsr: 'Average asset sustainability ratio ',
  relativeRiskAssessment: 'Relative risk assessment',
  averageRemainingUsefulLifeOfInfrastructureAssets:
    'Average remaining use life of infrastructure assets',
  _trend: 'Should not be displayed',

  // New for 2021
  ratesAndLevies: 'Rates and levies',
  miscellaneousIncome: 'Miscellaneous income',
  employeeBenefitsExpense: 'Employee benefits expenses',
  borrowingFinanceCosts: 'Borrowing/finance costs',
  materialsAndServices: 'Materials and services',
  depreciationAmortisationExpense: 'Depreciation and amortisation',
  capitalExpenditure: 'Capital expenditure',
  currentContractAssets: 'Current contract assets',
  nonCurrentContractAssets: 'Non-current contract assets',
  nonCurrentRightOfUseAssets: 'Non-current right-of-use assets',
  currentContractLiabilities: 'Current contract liabilities',
  currentLeaseLiabilities: 'Current lease liabilities',
  nonCurrentLeaseLiabilities: 'Non-current lease liabilities',
};
const labelMatcher = (str) => {
  const label = LabelMapper[str];
  if (!label) {
    throw Error('Missing label for: ' + str);
  }
  return label;
};
export default labelMatcher;



// WEBPACK FOOTER //
// ./src/helpers/label-mapper.js